export const getRoomsDetail = (
  data,
  periods,
  dmcOrganization,
  toOrganization,
) => {
  const rooms = [];

  data?.data.forEach((contract) => {
    contract.rooms.forEach((room) => {
      let roomInArray = rooms.find((elem) => elem.id === room.id);

      if (!roomInArray) {
        roomInArray = {
          id: room.id,
          name: room.name,
          periods: [],
          enabled: true,
        };

        rooms.push(roomInArray);
      }

      const periodsWithAllotment = room.periods;

      periodsWithAllotment.forEach((period) => {
        let periodInArray = roomInArray.periods.find(
          (elem) => elem.id === period.id,
        );

        const periodOrgaWithAllotment = period.periodOrganizations.find(
          (item) => item?.organization?.id === toOrganization?.id,
        );

        if (!periodInArray) {
          periodInArray = {
            id: period.id,
            startAt: period.startAt,
            endAt: period.endAt,
            freeSale: period.freeSale,
            totalAllotmentsAvailable: period.totalAllotmentsAvailable,
            toElement: {
              isPeriodAllowedForBooking:
                periodOrgaWithAllotment?.isPeriodAllowedForBooking,
              totalAllotmentsAvailableForDistribution:
                period.totalAllotmentsAvailable -
                period.totalSharedAllotmentsAvailable -
                period.periodOrganizations
                  .filter(
                    (elem) =>
                      elem.organization.id !== dmcOrganization?.id &&
                      elem.organization.id !== toOrganization?.id,
                  )
                  .reduce((acc, value) => acc + value.allotmentCount, 0),
            },
            allAllocations: period.periodOrganizations.filter(
              (elem) => elem.organization.id !== toOrganization?.id,
            ),
          };
          roomInArray.periods.push(periodInArray);
        }

        const periodInHotel = periods?.find((elem) => elem.id === period.id);

        if (periodInHotel) {
          const isPeriodAllowed =
            periodInHotel?.isPeriodAllowedForBooking ?? false;

          periodInArray.toElement = {
            ...periodInArray.toElement,
            allotmentCount: periodInHotel.allotmentCount,
            freeSale: periodInHotel.freeSale,
            isMarginPercent: periodInHotel?.isMarginPercent,
            margin: periodInHotel?.margin,
            isPeriodAllowedForBooking: isPeriodAllowed,
          };
        } else {
          const periodOrgaTo = period.periodOrganizations.find(
            (elem) => elem.organization.id === toOrganization?.id,
          );

          if (!periodOrgaTo) {
            periodInArray.toElement = {
              ...periodInArray.toElement,
              allotmentCount: 0,
              freeSale: false,
              isPeriodAllowedForBooking: false,
            };
          } else {
            const isPeriodAllowed =
              periodOrgaTo.isPeriodAllowedForBooking ?? false;

            periodInArray.toElement = {
              ...periodInArray.toElement,
              allotmentCount: periodOrgaTo.allotmentCount,
              freeSale: periodOrgaTo.freeSale,
              isPeriodAllowedForBooking: isPeriodAllowed,
              isMarginPercent: periodOrgaTo?.isMarginPercent,
              margin: periodOrgaTo?.margin,
            };
          }
        }
      });
    });
  });

  // After processing all contracts and periods, a room is enabled if at least
  // one of its periods is allowed for booking.
  rooms.forEach((room) => {
    room.enabled = room.periods.some((period) =>
      Boolean(period.toElement?.isPeriodAllowedForBooking),
    );
  });

  return rooms;
};
